export enum ActionTypes {
  GET_INSIGHTS_WORD_CLOUD_REQUEST = "@@insight_word_cloud/GET_INSIGHTS_WORD_CLOUD_REQUEST",
  GET_INSIGHTS_WORD_CLOUD_SUCCESS = "@@insight_word_cloud/GET_INSIGHTS_WORD_CLOUD_SUCCESS",
  GET_INSIGHTS_WORD_CLOUD_FAILURE = "@@insight_word_cloud/GET_INSIGHTS_WORD_CLOUD_FAILURE",
}
